var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonAuthorizationServer = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M8.082 20.62c-.156 0-.06-.679.058-1.366.117-.674.296-1.335.54-1.974l2.89-7.537C11.935 8.76 12.492 8 13.387 8H34.32c.898 0 1.452.76 1.82 1.743l2.89 7.537c.244.639.426 1.3.54 1.974.119.687.214 1.365.058 1.365M8.082 34.499c-.156 0-.061-.678.058-1.366a10.53 10.53 0 01.54-1.973l2.89-7.538c.365-.983.922-1.742 1.82-1.742h20.932c.897 0 1.451.76 1.82 1.742l2.889 7.538c.244.638.426 1.3.54 1.973.119.688.215 1.366.058 1.366", fill: fills.light }),
        React.createElement("path", { d: "M10.342 32.204H37.38a2.326 2.326 0 012.325 2.325v5.261a2.326 2.326 0 01-2.325 2.325H10.34a2.326 2.326 0 01-2.325-2.325V34.53a2.326 2.326 0 012.326-2.325z", fill: fills.base }),
        React.createElement("path", { d: "M34.911 38.248a1.167 1.167 0 100-2.335 1.167 1.167 0 000 2.335z", fill: fills.dark }),
        React.createElement("path", { d: "M10.342 18.324H37.38a2.326 2.326 0 012.325 2.325v5.261a2.326 2.326 0 01-2.325 2.326H10.34a2.326 2.326 0 01-2.325-2.326v-5.26a2.326 2.326 0 012.326-2.326z", fill: fills.base }),
        React.createElement("path", { d: "M34.911 24.368a1.167 1.167 0 100-2.335 1.167 1.167 0 000 2.335zM36.117 4.223l-4.032 2.93c-.41.296-.579.824-.425 1.304l1.54 4.74c.156.48.604.806 1.11.806h4.982c.505 0 .953-.326 1.11-.806l1.539-4.74a1.166 1.166 0 00-.425-1.304l-4.03-2.93a1.169 1.169 0 00-1.37 0z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
